const GoogleMaps = () => {

    let init = ( item ) => {

        let container = item,
            position = {
                lat: parseFloat(item.dataset.lat),
                lng: parseFloat(item.dataset.lng),
            },
            zoom = 14;

        let map = new google.maps.Map(container, {
            center: position,
            zoom: zoom
        });

        let marker = new google.maps.Marker({
            position: position,
            map: map
        });


    }

    window.initMap = () => {
        let mapContainer = document.getElementById('gmap');
        if (mapContainer) {
            init(mapContainer);
        }
        return;
    }


}

export default GoogleMaps;